<ng-container *transloco="let t">
    <mat-card
        class="altair-card endpoints-card bg-white border-radius border-none d-block"
        [class.component-dark-theme]="themeService.isDark()"
    >
        <mat-card-content>
            <h4 class="header-title mb-0"><i class="fe-activity"></i>&nbsp;{{ t('target-information') }}</h4>
            @if (scan) {
            <mat-tab-group dynamicHeight>
                <mat-tab label="{{ t('domain-info') }}">
                    @if (!scan.domain?.domainInfo) {
                    <div class="alert alert-danger alert-dismissible fade show" role="alert" id="whois_not_fetched_alert">
                        WHOIS Record Has not been fetched
                    </div>
                    }
                    <div class="alert alert-info alert-dismissible fade show" role="alert" id="whois_fetching_alert" style="display: none">
                        Fetching WHOIS records, Please wait...
                        <div class="spinner-border spinner-border-sm float-end" role="status"></div>
                    </div>
                    <div class="alert alert-success alert-dismissible fade show" role="alert" id="whois_fetched_alert" style="display: none">
                        WHOIS Records have been fetched, please <a href="javascript:location.reload();">reload the page.</a>
                    </div>
                    <div class="row">
                        <div class="col-4">
                            <small class="sub-header">Domain</small>
                            <h5>{{scan.domain?.name}}</h5>
                        </div>
                        <div class="col-4">
                            <small class="sub-header">Dnssec</small>
                            <h5>{{scan.domain?.domainInfo?.dnssec}}</h5>
                        </div>
                        <div class="col-4">
                            <small class="sub-header">Geolocation</small>
                            <h5>{{scan.domain?.domainInfo?.geolocation_iso | uppercase }}<span class="ms-2 fi fi-{{scan.domain?.domainInfo?.geolocation_iso | lowercase}}"></span></h5>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4">
                            <small class="sub-header">Created</small>
                            <h5>{{scan.domain?.domainInfo?.created}}</h5>
                        </div>
                        <div class="col-4">
                            <small class="sub-header">Updated</small>
                            <h5>{{scan.domain?.domainInfo?.updated}}</h5>
                        </div>
                        <div class="col-4">
                            <small class="sub-header">Expires</small>
                            <h5>{{scan.domain?.domainInfo?.expires}}</h5>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <small class="sub-header">Whois Server</small>
                            <h5>{{scan.domain?.domainInfo?.whois_server}}</h5>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4">
                            <small class="sub-header">Registrar Name</small>
                            <h5>{{scan.domain?.domainInfo?.registrar?.name}}</h5>
                        </div>
                        <div class="col-4">
                            <small class="sub-header">Registrar Phone</small>
                            <h5>{{scan.domain?.domainInfo?.registrar?.phone}}</h5>
                        </div>
                        <div class="col-4">
                            <small class="sub-header">Registrar Email</small>
                            <h5>{{scan.domain?.domainInfo?.registrar?.email}}</h5>
                        </div>
                    </div>
                    @for (status of scan.domain?.domainInfo?.status; track status) {
                        @if (status.name.includes('prohibited')) {
                            <span class="badge badge-soft-danger mt-1">{{status.name}}</span>
                        }
                        @else {
                            <span class="badge badge-soft-success mt-1">{{status.name}}</span>
                        }
                    }
                </mat-tab>
                <mat-tab label="{{ t('whois') }}">
                    <mat-tab-group headerPosition="below">
                        <mat-tab label="Registrant">
                            <div class="table-responsive">
                                <table class="table mb-0">
                                    <tbody>
                                        <tr class="table-info">
                                            <td><b>ID</b></td>
                                            <td><span class="fe-user"></span>&nbsp;{{scan.domain?.domainInfo?.registrant?.id_str}}</td>
                                        </tr>
                                        <tr class="">
                                            <td><b>Name</b></td>
                                            <td><span class="fe-user"></span>&nbsp;{{scan.domain?.domainInfo?.registrant?.name}}</td>
                                        </tr>
                                        <tr class="table-primary">
                                            <td><b>Organization</b></td>
                                            <td><span class="fe-briefcase"></span>&nbsp;{{scan.domain?.domainInfo?.registrant?.organization}}</td>
                                        </tr>
                                        <tr class="">
                                            <td><b>Email</b></td>
                                            <td><span class="fe-mail"></span>&nbsp;{{scan.domain?.domainInfo?.registrant?.email}}</td>
                                        </tr>
                                        <tr class="table-info">
                                            <td><b>Phone/Fax</b></td>
                                            <td>
                                                @if (scan.domain?.domainInfo?.registrant?.phone) {
                                                <span class="fe-phone"></span>&nbsp;{{scan.domain?.domainInfo?.registrant?.phone}}
                                                }
                                                @if (scan.domain?.domainInfo?.registrant?.fax) {
                                                <span class="fe-printer"></span>&nbsp;{{scan.domain?.domainInfo?.registrant?.fax}}
                                                }
                                            </td>
                                        </tr>
                                        <tr class="">
                                            <td><b>Address</b></td>
                                            <td><span class="fe-home"></span>&nbsp;{{scan.domain?.domainInfo?.registrant?.address}}</td>
                                        </tr>
                                        <tr class="table-danger">
                                            <td><b>Address</b></td>
                                            <td><b>City: </b>{{scan.domain?.domainInfo?.registrant?.city}} <b>State: </b>{{scan.domain?.domainInfo?.registrant?.state}} <b>Zip Code: </b>{{scan.domain?.domainInfo?.registrant?.zip_code}} <b>Country:
                                            </b>{{scan.domain?.domainInfo?.registrant?.country}} </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </mat-tab>
                        <mat-tab label="Administrative">
                            <div class="table-responsive">
                                <table class="table mb-0">
                                    <tbody>
                                        <tr class="table-info">
                                            <td><b>ID</b></td>
                                            <td><span class="fe-user"></span>&nbsp;{{scan.domain?.domainInfo?.admin?.id_str}}</td>
                                        </tr>
                                        <tr class="">
                                            <td><b>Name</b></td>
                                            <td><span class="fe-user"></span>&nbsp;{{scan.domain?.domainInfo?.admin?.name}}</td>
                                        </tr>
                                        <tr class="table-primary">
                                            <td><b>Organization</b></td>
                                            <td><span class="fe-briefcase"></span>&nbsp;{{scan.domain?.domainInfo?.admin?.organization}}</td>
                                        </tr>
                                        <tr class="">
                                            <td><b>Email</b></td>
                                            <td><span class="fe-mail"></span>&nbsp;{{scan.domain?.domainInfo?.admin?.email}}</td>
                                        </tr>
                                        <tr class="table-info">
                                            <td><b>Phone/Fax</b></td>
                                            <td>
                                                @if (scan.domain?.domainInfo?.admin?.phone) {
                                                <span class="fe-phone"></span>&nbsp;{{scan.domain?.domainInfo?.admin?.phone}}
                                                }
                                                @if (scan.domain?.domainInfo?.admin?.fax) {
                                                <span class="fe-printer"></span>&nbsp;{{scan.domain?.domainInfo?.admin?.fax}}
                                                }
                                            </td>
                                        </tr>
                                        <tr class="">
                                            <td><b>Address</b></td>
                                            <td><span class="fe-home"></span>&nbsp;{{scan.domain?.domainInfo?.admin?.address}}</td>
                                        </tr>
                                        <tr class="table-danger">
                                            <td><b>Address</b></td>
                                            <td><b>City: </b>{{scan.domain?.domainInfo?.admin?.city}} <b>State: </b>{{scan.domain?.domainInfo?.admin?.state}} <b>Zip Code: </b>{{scan.domain?.domainInfo?.admin?.zip_code}} <b>Country:
                                            </b>{{scan.domain?.domainInfo?.admin?.country}} </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </mat-tab>
                        <mat-tab label="Technical">
                            <div class="table-responsive">
                                <table class="table mb-0">
                                    <tbody>
                                        <tr class="table-info">
                                            <td><b>ID</b></td>
                                            <td><span class="fe-user"></span>&nbsp;{{scan.domain?.domainInfo?.admin?.id_str}}</td>
                                        </tr>
                                        <tr class="">
                                            <td><b>Name</b></td>
                                            <td><span class="fe-user"></span>&nbsp;{{scan.domain?.domainInfo?.admin?.name}}</td>
                                        </tr>
                                        <tr class="table-primary">
                                            <td><b>Organization</b></td>
                                            <td><span class="fe-briefcase"></span>&nbsp;{{scan.domain?.domainInfo?.admin?.organization}}</td>
                                        </tr>
                                        <tr class="">
                                            <td><b>Email</b></td>
                                            <td><span class="fe-mail"></span>&nbsp;{{scan.domain?.domainInfo?.admin?.email}}</td>
                                        </tr>
                                        <tr class="table-info">
                                            <td><b>Phone/Fax</b></td>
                                            <td>
                                                @if (scan.domain?.domainInfo?.admin?.phone) {
                                                <span class="fe-phone"></span>&nbsp;{{scan.domain?.domainInfo?.admin?.phone}}
                                                }
                                                @if (scan.domain?.domainInfo?.admin?.fax) {
                                                <span class="fe-printer"></span>&nbsp;{{scan.domain?.domainInfo?.admin?.fax}}
                                                }
                                            </td>
                                        </tr>
                                        <tr class="">
                                            <td><b>Address</b></td>
                                            <td><span class="fe-home"></span>&nbsp;{{scan.domain?.domainInfo?.admin?.address}}</td>
                                        </tr>
                                        <tr class="table-danger">
                                            <td><b>Address</b></td>
                                            <td><b>City: </b>{{scan.domain?.domainInfo?.tech?.city}} <b>State: </b>{{scan.domain?.domainInfo?.tech?.state}} <b>Zip Code: </b>{{scan.domain?.domainInfo?.tech?.zip_code}} <b>Country:
                                            </b>{{scan.domain?.domainInfo?.tech?.country}} </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </mat-tab>
                    </mat-tab-group>
                </mat-tab>
                <mat-tab label="{{ t('nameservers') }}">
                    @if (scan.domain?.domainInfo?.nameServers) {
                        <div class="alert alert-success">{{scan.domain?.domainInfo?.nameServers?.length}} NameServers identified</div>
                        @for (nameserver of scan.domain?.domainInfo?.nameServers; track nameserver) {
                            <span class="badge badge-soft-primary me-1 mt-1">{{nameserver}}</span>
                        }
                    }
                    @else {
                        <div class="alert alert-info">No NameServers identified</div>
                    }
                </mat-tab>
                <mat-tab label="{{ t('dns-records') }}">
                    <h4>A Records</h4>
                    @for (dns of scan.domain?.domainInfo?.dnsRecords; track dns) {
                        @if (dns.type == 'a') {
                            <span class="badge badge-soft-primary me-1 mt-1">{{ dns }}</span>
                        }
                    }
                    <h4>MX Records</h4>
                    @for (dns of scan.domain?.domainInfo?.dnsRecords; track dns) {
                        @if (dns.type == 'mx') {
                            <span class="badge badge-soft-primary me-1 mt-1">{{ dns }}</span>
                        }
                    }
                    <h4>TXT Records</h4>
                    @for (dns of scan.domain?.domainInfo?.dnsRecords; track dns) {
                        @if (dns.type == 'txt') {
                            <span class="badge badge-soft-secondary me-1 mt-1">{{ dns }}</span>
                        }
                    }
                </mat-tab>
                <mat-tab label="{{ t('historical-ips') }}">
                    @if (scan.domain?.domainInfo?.historicalIps) {
                    <div class="alert alert-success">{{scan.domain?.domainInfo?.historicalIps?.length}} Historical Ips</div>
                    <table id="basic-datatable" class="table dt-responsive w-100">
                        <thead>
                                <tr>
                                        <th>IP</th>
                                        <th>Location</th>
                                        <th>Owner</th>
                                        <th>Last Seen</th>
                                </tr>
                        </thead>
                        <tbody>
                            @for (ip of scan.domain?.domainInfo?.historicalIps; track ip) {
                            <tr>
                                <td><b>{{ip.ip}}</b></td>
                                <td>{{ip.location}}</td>
                                <td>{{ip.owner}}</td>
                                <td>{{ip.last_seen}}</td>
                            </tr>
                            }
                        </tbody>
                    </table>
                    }
                    @else {
                    <div class="alert alert-info">No historical IPs found!</div>
                    }
                </mat-tab>
                <mat-tab label="{{ t('nameservers') }}">
                    @if (scan.domain?.domainInfo?.nameServers) {
                        <div class="alert alert-success">{{scan.domain?.domainInfo?.nameServers?.length}} NameServers identified</div>
                        @for (nameserver of scan.domain?.domainInfo?.nameServers; track nameserver) {
                            <span class="badge badge-soft-primary me-1 mt-1">{{ nameserver}}</span>
                        }
                    }
                    @else {
                        <div class="alert alert-info">No NameServers identified</div>
                    }
                </mat-tab>
                <mat-tab label="{{ t('related-domains') }}">
                    @if (scan.domain?.domainInfo?.relatedDomains) {
                        <div class="alert alert-success">{{scan.domain?.domainInfo?.relatedDomains?.length}} Related Domains identified</div>
                    }
                    @else {
                        <div class="alert alert-info">No Related Domains identified</div>
                    }
                </mat-tab>
                <mat-tab label="{{ t('related-tlds') }}">
                    @if (scan.domain?.domainInfo?.relatedTlds) {
                        <div class="alert alert-success">{{scan.domain?.domainInfo?.relatedTlds?.length}} Related TLDs identified</div>
                    }
                    @else {
                        <div class="alert alert-info">No Related TLDs identified</div>
                    }
                </mat-tab>
            </mat-tab-group>
            }
        </mat-card-content>
    </mat-card>
</ng-container>
